import type { Locale } from '../Entities/Locale/Locale.entity';
import type { SortTypes } from '../Entities/Search/Sort.entity';

const SORT_OPTIONS_UK = [
  'relevance-desc',
  'distance-asc',
  'year-asc',
  'year-desc',
  'price-asc',
  'price-desc',
  'mileage-asc',
  'mileage-desc',
  'date-active-desc',
];

const DEFAULT_SORTING: { [key in Locale]?: SortTypes } = {
  uk: 'relevance-desc',
};

const SORT_KEY = 'sort';

export { DEFAULT_SORTING, SORT_KEY, SORT_OPTIONS_UK };
